import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vue3Toastify from 'vue3-toastify';

// Usa variável de ambiente ou URL local para desenvolvimento
axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'http://localhost:8000/api';

// Garantir UTF-8 em todas as requisições
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json; charset=UTF-8';

// Interceptor para adicionar token em todas as requisições
axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('UAUTHTKKEY');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

const app = createApp(App)
app.use(router)
app.config.globalProperties.$axios = axios
app.use(VueAxios, axios)
app.use(Vue3Toastify, {
    "autoClose": 3000,
    "position": "bottom-right",
    "transition": "bounce",
    "dangerouslyHTMLString": true
});
app.mount('#app');
